import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';
import { requiredFormValidator } from '@/ui-kit/components/form/validators';
import FormGroup from '@/ui-kit/components/form/entities/FormGroup';
import FormControl from '@/ui-kit/components/form/entities/FormControl';

export const MarketDataFilterFormControlName = {
  Province: 'province',
  City: 'city',
  TransactionDate: 'transactionDate',
  Community: 'community',
  BuildingClass: 'buildingClass',
  Beds: 'beds',
  Baths: 'baths',
  MinPrice: 'minPrice',
  MaxPrice: 'maxPrice',
  MinYearBuilt: 'minYearBuilt',
  MaxYearBuilt: 'maxYearBuilt',
};

export const MARKET_DATA_FILTER_FORM_DEFAULT_VALUE = {
  [MarketDataFilterFormControlName.Province]: '',
  [MarketDataFilterFormControlName.City]: '',
  [MarketDataFilterFormControlName.TransactionDate]: '',
  [MarketDataFilterFormControlName.Community]: [],
  [MarketDataFilterFormControlName.BuildingClass]: [],
  [MarketDataFilterFormControlName.Beds]: [],
  [MarketDataFilterFormControlName.Baths]: [],
  [MarketDataFilterFormControlName.MinPrice]: '',
  [MarketDataFilterFormControlName.MaxPrice]: '',
  [MarketDataFilterFormControlName.MinYearBuilt]: '',
  [MarketDataFilterFormControlName.MaxYearBuilt]: '',
};

const createMarketDataFilterForm = (defaultValue) => {
  const defaults = { ...MARKET_DATA_FILTER_FORM_DEFAULT_VALUE, ...defaultValue };
  return new FormGroup({
    [MarketDataFilterFormControlName.Province]: new FormControl(
      defaults[MarketDataFilterFormControlName.Province],
      [requiredFormValidator],
    ),
    [MarketDataFilterFormControlName.City]: new FormControl(
      defaults[MarketDataFilterFormControlName.City],
      [requiredFormValidator],
    ),
    [MarketDataFilterFormControlName.TransactionDate]: new FormControl(
      defaults[MarketDataFilterFormControlName.TransactionDate],
      [requiredFormValidator],
    ),
    [MarketDataFilterFormControlName.Community]: new FormControl(
      defaults[MarketDataFilterFormControlName.Community],
    ),
    [MarketDataFilterFormControlName.BuildingClass]: new FormControl(
      defaults[MarketDataFilterFormControlName.BuildingClass],
    ),
    [MarketDataFilterFormControlName.Beds]: new FormControl(
      defaults[MarketDataFilterFormControlName.Beds],
    ),
    [MarketDataFilterFormControlName.Baths]: new FormControl(
      defaults[MarketDataFilterFormControlName.Baths],
    ),
    [MarketDataFilterFormControlName.MinYearBuilt]: new FormControl(
      defaults[MarketDataFilterFormControlName.MinYearBuilt],
    ),
    [MarketDataFilterFormControlName.MaxYearBuilt]: new FormControl(
      defaults[MarketDataFilterFormControlName.MaxYearBuilt],
    ),
    [MarketDataFilterFormControlName.MinPrice]: new FormControl(
      defaults[MarketDataFilterFormControlName.MinPrice],
    ),
    [MarketDataFilterFormControlName.MaxPrice]: new FormControl(
      defaults[MarketDataFilterFormControlName.MaxPrice],
    ),
  }, [FormControlValidationStrategy.Change, FormControlValidationStrategy.Blur]);
};

export default createMarketDataFilterForm;
